import { util } from 'echarts';
import { ThemeParser } from '../../../core/theme';
import { normalizeToArray } from '../../../util/utils';
import type { PresetMode } from '../..';
import { labelLayout, defaultPie } from '../../ainvest/series/pie';
import styles from '../../ainvest/styles.module.less';

const OFFSET = 8;

function parsePieSeries(
  pieSeriesOptions: Parameters<ThemeParser>[0]['series'],
  chart: Parameters<ThemeParser>[1],
  themeMode: PresetMode
) {
  const defaultOption = {
    ...defaultPie(themeMode),
    labelLayout: labelLayout(chart),
    // 按设计师要求，在 pie 下 tooltip 跟随鼠标
    tooltip: {
      show: true,
      backgroundColor: '#383838',
      position: (point, params, dom: HTMLElement) => {
        dom.classList.remove(styles['ainvest-tooltip-triangle']);
        dom.classList.add([styles['ainvest-tooltip-show']]);
        return [point[0] + OFFSET, point[1] + OFFSET];
      }
    }
  };

  (pieSeriesOptions as []).forEach((series, index) => {
    // @ts-ignore
    if (series.type !== 'pie') {
      return;
    }
    const defaultPieOption = util.clone(defaultOption);
    pieSeriesOptions[index] = util.merge(defaultPieOption, series, true);
  });
}

export function pieThemeParse(...args: Parameters<ThemeParser>) {
  const [option, chart] = args;
  option.series = normalizeToArray(option.series);
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  parsePieSeries(option.series, chart, themeMode);
}
